import { formatAmericanOdds } from "./pricing.js";

const WIDTH = 1200;
const HEIGHT = 630;

function factor(value) {
  return `${Number(value).toFixed(2)}x`;
}

export function shareCardTextLines({
  fairOdds,
  offeredOdds,
  correlationCheck,
  legCount,
  gameCount,
}) {
  const structure = gameCount === 1
    ? `${legCount}-leg same-game parlay`
    : `${legCount}-leg parlay across ${gameCount} games`;
  return [
    structure,
    `Fair price ${formatAmericanOdds(fairOdds)}`,
    `Entered price ${formatAmericanOdds(offeredOdds)}`,
    `Book bundle premium ${factor(correlationCheck.bookCorrelationFactor)}`,
    `PricedPlay model factor ${factor(correlationCheck.modelCorrelationFactor)}`,
    "The premium covers correlation, extra margin, or both.",
    "pricedplay.com",
  ];
}

export function drawShareCard(input, createCanvas = () => document.createElement("canvas")) {
  const canvas = createCanvas();
  canvas.width = WIDTH;
  canvas.height = HEIGHT;
  const context = canvas.getContext("2d");
  if (!context) throw new Error("Canvas is unavailable");
  const lines = shareCardTextLines(input);

  const gradient = context.createLinearGradient(0, 0, WIDTH, HEIGHT);
  gradient.addColorStop(0, "#050812");
  gradient.addColorStop(1, "#111722");
  context.fillStyle = gradient;
  context.fillRect(0, 0, WIDTH, HEIGHT);

  context.fillStyle = "#50f0b0";
  context.fillRect(72, 62, 12, 64);
  context.fillStyle = "#f7f9fc";
  context.font = "700 52px Inter, system-ui, sans-serif";
  context.fillText("PricedPlay", 110, 112);

  context.fillStyle = "#b8bec9";
  context.font = "600 25px Inter, system-ui, sans-serif";
  context.fillText(lines[0], 72, 176);

  context.fillStyle = "#f7f9fc";
  context.font = "750 54px Inter, system-ui, sans-serif";
  context.fillText(lines[1], 72, 260);
  context.fillText(lines[2], 650, 260);

  context.strokeStyle = "#343b49";
  context.lineWidth = 2;
  context.beginPath();
  context.moveTo(72, 304);
  context.lineTo(1128, 304);
  context.stroke();

  context.fillStyle = "#50cff2";
  context.font = "700 31px Inter, system-ui, sans-serif";
  context.fillText(lines[3], 72, 370);
  context.fillText(lines[4], 72, 422);

  context.fillStyle = "#f7f9fc";
  context.font = "600 27px Inter, system-ui, sans-serif";
  context.fillText(lines[5], 72, 490);

  context.fillStyle = "#50f0b0";
  context.font = "700 28px Inter, system-ui, sans-serif";
  context.fillText(lines[6], 72, 560);
  return canvas;
}

function canvasBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("PNG generation failed"));
    }, "image/png");
  });
}

export async function downloadAndShareCard(
  input,
  {
    documentObject = document,
    navigatorObject = navigator,
    urlObject = URL,
    createCanvas,
  } = {},
) {
  const canvas = drawShareCard(input, createCanvas);
  const blob = await canvasBlob(canvas);
  const filename = "pricedplay-parlay-check.png";
  const objectURL = urlObject.createObjectURL(blob);
  const link = documentObject.createElement("a");
  link.href = objectURL;
  link.download = filename;
  documentObject.body.append(link);
  link.click();
  link.remove();

  try {
    if (typeof navigatorObject.share === "function") {
      const file = new File([blob], filename, { type: "image/png" });
      const filePayload = { files: [file] };
      const payload = typeof navigatorObject.canShare === "function"
        && navigatorObject.canShare(filePayload)
        ? {
            ...filePayload,
            title: "PricedPlay parlay check",
            text: "My PricedPlay parlay price check",
          }
        : {
            title: "PricedPlay parlay check",
            text: "My PricedPlay parlay price check — pricedplay.com",
          };
      await navigatorObject.share(payload);
    }
  } finally {
    urlObject.revokeObjectURL(objectURL);
  }
}
